var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mall-qa wrap"},[_c('h2',[_vm._v("Frequent Q&A")]),_c('p',{staticClass:"sub-title"},[_vm._v("よくある質問")]),_vm._l((_vm.qaBoxList),function(qaBoxListData){return _c('UiQaQaBox',{key:qaBoxListData.id,attrs:{"qestion":qaBoxListData.qestion,"answer":qaBoxListData.answer}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }